<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">
            <button mat-icon-button class="crud_action" matTooltip="update" (click)="updateTestStep()" [disabled]="!isContentChanged" *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>

            <span class="example-spacer"></span>

            <button mat-icon-button class="crud_action" matTooltip="add a test step" (click)="createTestStep()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button class="crud_action" matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                <mat-icon>delete_outline</mat-icon>
            </button>
        </mat-toolbar>

        <form class="example-form" (change)="onContentChange()">
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>SN</mat-label>
                <input type="text" name="inputName" matInput [(ngModel)]="testStep.sn" [readonly]="isReadonly">
            </mat-form-field>
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Method</mat-label>
                <textarea type="text" name="textDesc" matInput [(ngModel)]="testStep.method" [readonly]="isReadonly"></textarea>
            </mat-form-field>
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Expected results</mat-label>
                <textarea type="email" name="inputExpected" matInput [(ngModel)]="testStep.expected_result" [readonly]="isReadonly"></textarea>
            </mat-form-field>
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Result</mat-label>
                <textarea type="text" name="inputResult" matInput [(ngModel)]="testStep.result" [readonly]="isReadonly"></textarea>
            </mat-form-field>
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Additional guidance notes</mat-label>
                <textarea type="text" name="inputGuideNotes" matInput [(ngModel)]="testStep.additional_guidance_notes" [readonly]="isReadonly"></textarea>
            </mat-form-field>
        </form>
    </mat-card-content>
</mat-card>
